import '../../css/nav.css'
import { pageHref } from '../util/pageHref.js'
import { initImageDefaults } from '../util/imageDefaults.js'
import { registerServiceWorker } from '../util/serviceWorker.js'
import { getLang, setLang } from '../util/i18n.js'
import { getNavTexts } from '../data/navTexts.js'

class SamtHeader extends HTMLElement {
  connectedCallback() {
    this.render()
    this.initNavbar()
    // 统一图片默认策略，并注册图片缓存 Service Worker
    initImageDefaults()
    registerServiceWorker()
  }

  render() {
    const lang = getLang()
    const t = getNavTexts(lang)

    this.innerHTML = `
      <header>
      <!-- nav -->
      <nav
        class="bg-samt text-white hover:bg-samt fixed top-0 z-30 h-20 w-screen transition-all duration-300 ease-in-out lg:bg-transparent shadow-none"
      >
        <div
          class="top-nav w-full flex h-full items-center justify-between px-4 lg:px-10"
        >
          <a
            href="/"
            class="flex h-[62px] w-[142px] items-center lg:justify-center"
          >
            <img
              id="samt-nav-logo"
              src="/src/assets/svg/web-SAMT-negative.svg"
              alt="samt"
              class="h-3/5 w-auto space-y-0.5 hover:cursor-pointer"
              data-eager="true"
            />
          </a>

          <div class="nav-space-empty w-35 h-1 hidden 2xl:block"></div>

          <ul
            class="nav-menu hidden h-16 text-base/16 text-white lg:flex lg:items-center xl:text-base/6"
          >
            <!-- Products -->
            <li class="nav-menu-li group flex">
              <span class="px-3 xl:px-6">${t.menu.products}</span>
              <div class="nav-menu-div block group-hover:block">
                <div class="nav-menu-gradient"></div>
                <div class="nav-menu-content w-3/5!">
                  <!-- column 1 -->
                  <div class="nav-column-item w-1/3 2xl:w-1/4">
                    <div class="nav-column-item-wideBody">
                      <span>${t.products.vacuumIndustrialFurnace}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('product', { product: 'vacuum-heat-treatment' })}">${t.products.vacuumHeatTreatment}</a>
                        <a href="${pageHref('product', { product: 'vacuum-brazing' })}">${t.products.vacuumBrazing}</a>
                        <a href="${pageHref('product', { product: 'vacuum-carburizing' })}">${t.products.vacuumCarburizing}</a>
                        <a href="${pageHref('product', { product: 'vacuum-nitriding' })}">${t.products.vacuumNitriding}</a>
                        <p class="block xl:hidden 2xl:block">&nbsp;</p>
                        <a href="${pageHref('product', { product: 'vacuum-aluminizing' })}">${t.products.vacuumAluminizing}</a>
                        <a href="${pageHref('product', { product: 'vacuum-sherardizing' })}">${t.products.vacuumSherardizing}</a>
                        <a href="${pageHref('product', { product: 'physical-vapor-deposition' })}">${t.products.physicalVaporDeposition}</a>
                        <a href="${pageHref('product', { product: 'chemical-vapour-deposition' })}">${t.products.chemicalVaporDeposition}</a>
                        <a href="${pageHref('product', { product: 'fluoride-ion-cleaning' })}">${t.products.fluorideIonCleaning}</a>
                        <p>&nbsp;</p>
                        <a href="${pageHref('product', { product: 'vacuum-induction-melting-and-casting' })}">${t.products.vacuumInductionMelting}</a>
                        <a href="${pageHref('product', { product: 'vacuum-induction-melting-and-investment-casting' })}">${t.products.vacuumInvestmentCasting}</a>
                      </div>
                    </div>
                  </div>
                  <!-- END column 1 -->

                  <!-- column 2 -->
                  <div class="nav-column-item w-5/12 gap-20 2xl:w-1/3">
                    <div class="nav-column-item-wideBody">
                      <span>${t.products.verticalModular}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('product', { product: 'multi-purpose-bottom-load-line' })}">${t.products.multiPurposeBottomLoad}</a>
                        <a href="${pageHref('product', { product: 'shaft-bottom-load-line' })}">${t.products.shaftBottomLoad}</a>
                      </div>
                    </div>

                    <div class="nav-column-item-wideBody">
                      <span>${t.products.nonFerrous}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('product', { product: 'titan-alloys' })}">${t.products.titanAlloys}</a>
                        <a href="${pageHref('product', { product: 'aluminum-alloys' })}">${t.products.aluminumAlloys}</a>
                        <a href="${pageHref('product', { product: 'magnesium-alloys' })}">${t.products.magnesiumAlloys}</a>
                      </div>
                    </div>
                  </div>
                  <!-- END column 2 -->

                  <!-- column 3 -->
                  <div class="nav-column-item w-1/4 gap-12 2xl:w-1/4">
                    <!-- Precision Cleaning System -->
                    <div class="nav-column-item-wideBody">
                      <span>${t.products.precisionCleaning}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('product', { product: 'vacuum-solvent-cleaning' })}">${t.products.vacuumSolventCleaning}</a>
                        <a href="${pageHref('product', { product: 'vacuum-hybrid-cleaning' })}">${t.products.vacuumHybridCleaning}</a>
                        <a href="${pageHref('product', { product: 'precision-aqueous-cleaning' })}">${t.products.aqueousPrecisionCleaning}</a>
                      </div>
                    </div>
                    <!-- end Precision Cleaning System -->

                    <div class="nav-column-item-wideBody">
                      <span>${t.products.heatTreatmentMedia}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('product', { product: 'quenching-media' })}">${t.products.quenchingMedia}</a>
                        <a href="${pageHref('product', { product: 'stop-off-paint' })}">${t.products.stopOffPaint}</a>
                        <a href="${pageHref('product', { product: 'cleaning-agent' })}">${t.products.cleaningAgent}</a>
                      </div>
                    </div>
                  </div>
                  <!-- END column 3 -->

                  <!-- column 4 -->
                  <div
                    class="nav-column-item hidden! w-0 gap-12 2xl:block! 2xl:w-0"
                  ></div>
                  <!-- END column 4 -->
                </div>
              </div>
            </li>
            <!-- END Products -->

            <!-- Processes -->
            <li class="nav-menu-li group flex">
              <span class="px-3 xl:px-6">${t.menu.processes}</span>
              <div class="nav-menu-div group-hover:block">
                <div class="nav-menu-gradient"></div>
                <div class="nav-menu-content">
                  <div
                    class="nav-column-item-empty w-0! xl:w-1/6 2xl:w-5/12!"
                  ></div>

                  <!-- processes-content -->
                  <div class="nav-column-item 3xl:w-7/12 w-1/2">
                    <div class="nav-column-item-wideBody">
                      <span>${t.processes.title}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('process', { process: 'heat-treatment' })}">${t.processes.heatTreating}</a>
                        <a href="${pageHref('process', { process: 'surface-engineering' })}">${t.processes.surfaceEngineering}</a>
                        <a href="${pageHref('process', { process: 'hot-isostatic-pressing' })}">${t.processes.hotIsostaticPressing}</a>
                        <a href="${pageHref('process', { process: 'metal-joining' })}">${t.processes.metalJoining}</a>
                        <a href="${pageHref('process', { process: 'testing-and-analysis' })}">${t.processes.testingAnalysis}</a>
                        <a href="${pageHref('process', { process: 'surface-cleaning' })}">${t.processes.surfaceCleaning}</a>
                        <a href="${pageHref('process-support')}">${t.processes.mediaSupport}</a>
                      </div>
                    </div>
                  </div>
                  <!-- end processes-content -->

                  <div
                    class="nav-column-item-empty w-0! xl:w-1/12!"
                  ></div>
                </div>
              </div>
            </li>
            <!-- END Processes -->

            <!-- Technology -->
            <li class="nav-menu-li group flex">
              <span class="px-3 xl:px-6">${t.menu.technologies}</span>
              <div class="nav-menu-div group-hover:block">
                <div class="nav-menu-gradient"></div>
                <div class="nav-menu-content">
                  <div
                    class="nav-column-item-empty w-0! xl:w-1/6 2xl:w-5/12!"
                  ></div>

                  <!-- technology-content -->
                  <div class="nav-column-item 3xl:w-7/12 w-1/2">
                    <div class="nav-column-item-wideBody">
                      <span>${t.technologies.title}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('technology', { technology: 'hpgq' })}">${t.technologies.hpgq}</a>
                        <a href="${pageHref('technology', { technology: 'lpc' })}">${t.technologies.lpc}</a>
                        <a href="${pageHref('technology', { technology: 'Shenlizing' })}">${t.technologies.shenlizing}</a>
                        <a href="${pageHref('technology', { technology: 'singerizing-sst' })}">${t.technologies.singerizingSst}</a>
                        <a href="${pageHref('technology', { technology: 'singerizing-ti' })}">${t.technologies.singerizingTi}</a>
                        <a href="${pageHref('technology', { technology: 'uhv' })}">${t.technologies.uhv}</a>
                        <a href="${pageHref('technology', { technology: 'uht' })}">${t.technologies.uht}</a>
                        <a href="${pageHref('technology', { technology: 'hybrid' })}">${t.technologies.hybrid}</a>
                        <a href="${pageHref('technology', { technology: 'cnp' })}">${t.technologies.cnp}</a>
                      </div>
                    </div>
                  </div>
                  <!-- end technology-content -->

                  <div
                    class="nav-column-item-empty w-0! xl:w-1/12!"
                  ></div>
                </div>
              </div>
            </li>
            <!-- END Technology -->

            <!-- Applications -->
            <li class="nav-menu-li group flex">
              <span class="px-3 xl:px-6">${t.menu.applications}</span>
              <div class="nav-menu-div group-hover:block">
                <div class="nav-menu-gradient"></div>
                <div class="nav-menu-content">
                  <div
                    class="nav-column-item-empty w-0! xl:w-1/6 2xl:w-5/12!"
                  ></div>

                  <!-- applications-content -->
                  <div class="nav-column-item 3xl:w-7/12 w-1/2">
                    <div class="nav-column-item-wideBody">
                      <span>${t.applications.title}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('application', { technology: 'gear' })}">${t.applications.gear}</a>
                        <a href="${pageHref('application', { technology: 'bearing' })}">${t.applications.bearing}</a>
                        <a href="${pageHref('application', { technology: 'springs' })}">${t.applications.springs}</a>
                        <a href="${pageHref('application', { technology: 'hydraulic' })}">${t.applications.hydraulic}</a>
                        <a href="${pageHref('application', { technology: 'turbine-blade' })}">${t.applications.turbineBlade}</a>
                        <a href="${pageHref('application', { technology: 'gas-turnine' })}">${t.applications.gasTurnine}</a>
                        <a href="${pageHref('application', { technology: 'common-rail' })}">${t.applications.commonRail}</a>
                        <a href="${pageHref('application', { technology: 'heat-exchanger' })}">${t.applications.heatExchanger}</a>
                        <a href="${pageHref('application', { technology: 'mim' })}">${t.applications.mim}</a>
                        <a href="${pageHref('application', { technology: 'additive-manufacturing' })}">${t.applications.additiveManufacturing}</a>
                      </div>
                    </div>
                  </div>
                  <!-- end applications-content -->

                  <div
                    class="nav-column-item-empty w-0! xl:w-1/12!"
                  ></div>
                </div>
              </div>
            </li>
            <!-- END Applications -->

            <!-- Industry -->
            <li class="nav-menu-li group flex">
              <span class="px-3 xl:px-6">${t.menu.industries}</span>
              <div class="nav-menu-div group-hover:block">
                <div class="nav-menu-gradient"></div>
                <div class="nav-menu-content">
                  <div
                    class="nav-column-item-empty w-0! xl:w-1/6 2xl:w-5/12!"
                  ></div>

                  <!-- industries-content -->
                  <div class="nav-column-item 3xl:w-7/12 w-1/2">
                    <div class="nav-column-item-wideBody">
                      <span>${t.industries.title}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('industry', { industry: 'aerospace' })}">${t.industries.aerospace}</a>
                        <a href="${pageHref('industry', { industry: 'automotive' })}">${t.industries.automotive}</a>
                        <a href="${pageHref('industry', { industry: 'rail-transit' })}">${t.industries.railTransit}</a>
                        <a href="${pageHref('industry', { industry: 'ship-and-marine' })}">${t.industries.shipMarine}</a>
                        <a href="${pageHref('industry', { industry: 'new-energy' })}">${t.industries.newEnergy}</a>
                        <a href="${pageHref('industry', { industry: 'oil-gas' })}">${t.industries.oilGas}</a>
                        <a href="${pageHref('industry', { industry: 'tools' })}">${t.industries.tools}</a>
                        <a href="${pageHref('industry', { industry: 'product-3c' })}">${t.industries.product3c}</a>
                        <a href="${pageHref('industry', { industry: 'medical' })}">${t.industries.medical}</a>
                        <a href="${pageHref('industry', { industry: 'semicon' })}">${t.industries.semicon}</a>
                        <a href="${pageHref('industry', { industry: 'robotics' })}">${t.industries.robotics}</a>
                      </div>
                    </div>
                  </div>
                  <!-- end industries-content -->

                  <div
                    class="nav-column-item-empty w-0! xl:w-1/12!"
                  ></div>
                </div>
              </div>
            </li>
            <!-- END  Industry-->

            <!-- NEWS -->
            <li class="nav-menu-li group flex">
              <span class="px-3 xl:px-6">${t.menu.news}</span>
              <div class="nav-menu-div group-hover:block">
                <div class="nav-menu-gradient"></div>
                <div class="nav-menu-content">
                  <div
                    class="nav-column-item-empty w-0! xl:w-1/6 2xl:w-5/12!"
                  ></div>

                  <!-- news-content -->
                  <div class="nav-column-item 3xl:w-7/12 w-1/2">
                    <div class="nav-column-item-wideBody">
                      <span>${t.news.title}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('articles')}">${t.news.pressReleases}</a>
                        <a href="#">${t.news.articles}</a>
                      </div>
                    </div>
                  </div>
                  <!-- end news-content -->

                  <div
                    class="nav-column-item-empty w-0! xl:w-1/12!"
                  ></div>
                </div>
              </div>
            </li>
            <!-- END NEWS -->

            <!-- Company -->
            <li class="nav-menu-li group flex">
              <span class="px-3 xl:px-6">${t.menu.company}</span>
              <div class="nav-menu-div group-hover:block">
                <div class="nav-menu-gradient"></div>
                <div class="nav-menu-content">
                  <div
                    class="nav-column-item-empty w-0! xl:w-1/6 2xl:w-5/12!"
                  ></div>

                  <!-- company-content -->
                  <div class="nav-column-item 3xl:w-7/12 w-1/2">
                    <div class="nav-column-item-wideBody">
                      <span>${t.company.title}</span>
                      <div class="wideBody-item">
                        <a href="${pageHref('about-us')}">${t.company.aboutUs}</a>
                        <!-- <a href="${pageHref('history')}">${t.company.history}</a> -->
                        <a href="#">${t.company.history}</a>
                        <a href="${pageHref('career')}">${t.company.careers}</a>
                        <a href="${pageHref('partner')}">${t.company.globalPartners}</a>
                      </div>
                    </div>
                  </div>
                  <!-- end company-content -->

                  <div
                    class="nav-column-item-empty w-0! xl:w-1/12!"
                  ></div>
                </div>
              </div>
            </li>
            <!-- END Company -->
          </ul>

          <div class="nav-space-empty w-10 h-1 hidden 2xl:block"></div>

          <!-- language and menu-items -->
          <div class="flex items-center gap-4 text-white duration-300">
            <div id="lang-switcher" class="flex items-center cursor-pointer select-none">
              <span id="lang-en" class="${getLang() === 'en' ? 'text-white' : 'text-gray-400 hover:text-white'}" data-lang="en">EN</span>
              <span class="mx-1 text-gray-400">|</span>
              <span id="lang-zh" class="${getLang() === 'zh' ? 'text-white' : 'text-gray-400 hover:text-white'}" data-lang="zh-CN">中文</span>
            </div>

            <button id="open-mobile-menu">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6 hover:text-stone-500 lg:hidden"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>
          </div>
          <!-- end language and menu-items -->
        </div>

        <!-- mobile menu -->
        <div
          class="mobile-menu bg-samt absolute top-0 right-0 hidden h-screen w-screen translate-x-full transform flex-col items-start transition-transform duration-300 lg:hidden"
          id="mobile-menu"
        >
          <div
            class="mobile-menu-close mx-auto flex h-16 w-9/10 items-center justify-end"
          >
            <button id="close-mobile-menu">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18 18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div
            class="mobile-menu-items mx-auto flex w-4/5 max-h-[calc(100vh-4rem)] flex-col items-start gap-4 overflow-y-auto pr-2 pb-2 text-base/8"
          >
            <div class="mobile-menu-item w-full">
              <div
                class="mobile-menu-toggle hover:b-l-2 mx-auto flex h-8 w-full cursor-pointer items-center justify-between border-l border-l-white pl-4 duration-300 hover:border-l-green-500 hover:pl-8 hover:text-blue-500"
              >
                <span>${t.menu.products}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-4 transition-transform duration-300"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </div>
              <div
                class="mobile-submenu hidden flex-col pt-2 pl-8"
              >
                <a
                  href="${pageHref('product', { product: 'vacuum-heat-treatment' })}"
                  >${t.products.vacuumHeatTreatment}</a
                >
                <a
                  href="${pageHref('product', { product: 'vacuum-brazing' })}"
                  >${t.products.vacuumBrazing}</a
                >
                <a
                  href="${pageHref('product', { product: 'vacuum-carburizing' })}"
                  >${t.products.vacuumCarburizing}</a
                >
                <a
                  href="${pageHref('product', { product: 'vacuum-nitriding' })}"
                  >${t.products.vacuumNitriding}</a
                >
                <a
                  href="${pageHref('product', { product: 'vacuum-aluminizing' })}"
                  >${t.products.vacuumAluminizing}</a
                >
                <a
                  href="${pageHref('product', { product: 'vacuum-sherardizing' })}"
                  >${t.products.vacuumSherardizing}</a
                >
                <a
                  href="${pageHref('product', { product: 'physical-vapor-deposition' })}"
                  >${t.products.physicalVaporDeposition}</a
                >
                <a
                  href="${pageHref('product', { product: 'chemical-vapour-deposition' })}"
                  >${t.products.chemicalVaporDeposition}</a
                >
                <a
                  href="${pageHref('product', { product: 'fluoride-ion-cleaning' })}"
                  >${t.products.fluorideIonCleaning}</a
                >
                <a
                  href="${pageHref('product', { product: 'vacuum-induction-melting-and-casting' })}"
                  >${t.products.vacuumInductionMelting}</a
                >
                <a
                  href="${pageHref('product', { product: 'vacuum-induction-melting-and-investment-casting' })}"
                  >${t.products.vacuumInvestmentCasting}</a
                >
                <a
                  href="${pageHref('product', { product: 'multi-purpose-bottom-load-line' })}"
                  >${t.products.multiPurposeBottomLoad}</a
                >
                <a
                  href="${pageHref('product', { product: 'shaft-bottom-load-line' })}"
                  >${t.products.shaftBottomLoad}</a
                >
                <a
                  href="${pageHref('product', { product: 'titan-alloys' })}"
                  >${t.products.titanAlloys}</a
                >
                <a
                  href="${pageHref('product', { product: 'aluminum-alloys' })}"
                  >${t.products.aluminumAlloys}</a
                >
                <a
                  href="${pageHref('product', { product: 'magnesium-alloys' })}"
                  >${t.products.magnesiumAlloys}</a
                >
                <a
                  href="${pageHref('product', { product: 'vacuum-solvent-cleaning' })}"
                  >${t.products.vacuumSolventCleaning}</a
                >
                <a
                  href="${pageHref('product', { product: 'vacuum-hybrid-cleaning' })}"
                  >${t.products.vacuumHybridCleaning}</a
                >
                <a
                  href="${pageHref('product', { product: 'precision-aqueous-cleaning' })}"
                  >${t.products.aqueousPrecisionCleaning}</a
                >
                <a
                  href="${pageHref('product', { product: 'quenching-media' })}"
                  >${t.products.quenchingMedia}</a
                >
                <a
                  href="${pageHref('product', { product: 'stop-off-paint' })}"
                  >${t.products.stopOffPaint}</a
                >
                <a
                  href="${pageHref('product', { product: 'cleaning-agent' })}"
                  >${t.products.cleaningAgent}</a
                >
              </div>
            </div>

            <div class="mobile-menu-item w-full">
              <div
                class="mobile-menu-toggle hover:b-l-2 mx-auto flex h-8 w-full cursor-pointer items-center justify-between border-l border-l-white pl-4 duration-300 hover:border-l-green-500 hover:pl-8 hover:text-blue-500"
              >
                <span>${t.menu.processes}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-4 transition-transform duration-300"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </div>
              <div
                class="mobile-submenu hidden flex-col pt-2 pl-8"
              >
                <a
                  href="${pageHref('process', { process: 'heat-treatment' })}"
                  >${t.processes.heatTreating}</a
                >
                <a
                  href="${pageHref('process', { process: 'surface-engineering' })}"
                  >${t.processes.surfaceEngineering}</a
                >
                <a
                  href="${pageHref('process', { process: 'hot-isostatic-pressing' })}"
                  >${t.processes.hotIsostaticPressing}</a
                >
                <a
                  href="${pageHref('process', { process: 'metal-joining' })}"
                  >${t.processes.metalJoining}</a
                >
                <a
                  href="${pageHref('process', { process: 'testing-and-analysis' })}"
                  >${t.processes.testingAnalysis}</a
                >
                <a
                  href="${pageHref('process', { process: 'surface-cleaning' })}"
                  >${t.processes.surfaceCleaning}</a
                >
                <a
                  href="${pageHref('process-support')}"
                  >${t.processes.mediaSupport}</a
                >
              </div>
            </div>

            <div class="mobile-menu-item w-full">
              <div
                class="mobile-menu-toggle hover:b-l-2 mx-auto flex h-8 w-full cursor-pointer items-center justify-between border-l border-l-white pl-4 duration-300 hover:border-l-green-500 hover:pl-8 hover:text-blue-500"
              >
                <span>${t.menu.technologies}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-4 transition-transform duration-300"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </div>
              <div
                class="mobile-submenu hidden flex-col pt-2 pl-8"
              >
                <a
                  href="${pageHref('technology', { technology: 'hpgq' })}"
                  >${t.technologies.hpgq}</a
                >
                <a
                  href="${pageHref('technology', { technology: 'lpc' })}"
                  >${t.technologies.lpc}</a
                >
                <a
                  href="${pageHref('technology', { technology: 'Shenlizing' })}"
                  >${t.technologies.shenlizing}</a
                >
                <a
                  href="${pageHref('technology', { technology: 'singerizing-sst' })}"
                  >${t.technologies.singerizingSst}</a
                >
                <a
                  href="${pageHref('technology', { technology: 'singerizing-ti' })}"
                  >${t.technologies.singerizingTi}</a
                >
                <a
                  href="${pageHref('technology', { technology: 'uhv' })}"
                  >${t.technologies.uhv}</a
                >
                <a
                  href="${pageHref('technology', { technology: 'uht' })}"
                  >${t.technologies.uht}</a
                >
                <a
                  href="${pageHref('technology', { technology: 'hybrid' })}"
                  >${t.technologies.hybrid}</a
                >
                <a
                  href="${pageHref('technology', { technology: 'cnp' })}"
                  >${t.technologies.cnp}</a
                >
              </div>
            </div>

            <div class="mobile-menu-item w-full">
              <div
                class="mobile-menu-toggle hover:b-l-2 mx-auto flex h-8 w-full cursor-pointer items-center justify-between border-l border-l-white pl-4 duration-300 hover:border-l-green-500 hover:pl-8 hover:text-blue-500"
              >
                <span>${t.menu.applications}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-4 transition-transform duration-300"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </div>
              <div
                class="mobile-submenu hidden flex-col pt-2 pl-8"
              >
                <a
                  href="${pageHref('application', { technology: 'gear' })}"
                  >${t.applications.gear}</a
                >
                <a
                  href="${pageHref('application', { technology: 'bearing' })}"
                  >${t.applications.bearing}</a
                >
                <a
                  href="${pageHref('application', { technology: 'springs' })}"
                  >${t.applications.springs}</a
                >
                <a
                  href="${pageHref('application', { technology: 'hydraulic' })}"
                  >${t.applications.hydraulic}</a
                >
                <a
                  href="${pageHref('application', { technology: 'turbine-blade' })}"
                  >${t.applications.turbineBlade}</a
                >
                <a
                  href="${pageHref('application', { technology: 'gas-turnine' })}"
                  >${t.applications.gasTurnine}</a
                >
                <a
                  href="${pageHref('application', { technology: 'common-rail' })}"
                  >${t.applications.commonRail}</a
                >
                <a
                  href="${pageHref('application', { technology: 'heat-exchanger' })}"
                  >${t.applications.heatExchanger}</a
                >
                <a
                  href="${pageHref('application', { technology: 'mim' })}"
                  >${t.applications.mim}</a
                >
                <a
                  href="${pageHref('application', { technology: 'additive-manufacturing' })}"
                  >${t.applications.additiveManufacturing}</a
                >
              </div>
            </div>

            <div class="mobile-menu-item w-full">
              <div
                class="mobile-menu-toggle hover:b-l-2 mx-auto flex h-8 w-full cursor-pointer items-center justify-between border-l border-l-white pl-4 duration-300 hover:border-l-green-500 hover:pl-8 hover:text-blue-500"
              >
                <span>${t.menu.industries}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-4 transition-transform duration-300"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </div>
              <div
                class="mobile-submenu hidden flex-col pt-2 pl-8"
              >
                <a
                  href="${pageHref('industry', { industry: 'aerospace' })}"
                  >${t.industries.aerospace}</a
                >
                <a
                  href="${pageHref('industry', { industry: 'automotive' })}"
                  >${t.industries.automotive}</a
                >
                <a
                  href="${pageHref('industry', { industry: 'rail-transit' })}"
                  >${t.industries.railTransit}</a
                >
                <a
                  href="${pageHref('industry', { industry: 'ship-and-marine' })}"
                  >${t.industries.shipMarine}</a
                >
                <a
                  href="${pageHref('industry', { industry: 'new-energy' })}"
                  >${t.industries.newEnergy}</a
                >
                <a
                  href="${pageHref('industry', { industry: 'oil-gas' })}"
                  >${t.industries.oilGas}</a
                >
                <a
                  href="${pageHref('industry', { industry: 'tools' })}"
                  >${t.industries.tools}</a
                >
                <a
                  href="${pageHref('industry', { industry: 'product-3c' })}"
                  >${t.industries.product3c}</a
                >
                <a
                  href="${pageHref('industry', { industry: 'medical' })}"
                  >${t.industries.medical}</a
                >
                <a
                  href="${pageHref('industry', { industry: 'semicon' })}"
                  >${t.industries.semicon}</a
                >
                <a
                  href="${pageHref('industry', { industry: 'robotics' })}"
                  >${t.industries.robotics}</a
                >
              </div>
            </div>

            <div class="mobile-menu-item w-full">
              <div
                class="mobile-menu-toggle hover:b-l-2 mx-auto flex h-8 w-full cursor-pointer items-center justify-between border-l border-l-white pl-4 duration-300 hover:border-l-green-500 hover:pl-8 hover:text-blue-500"
              >
                <span>${t.menu.news}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-4 transition-transform duration-300"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </div>
              <div
                class="mobile-submenu hidden flex-col pt-2 pl-8"
              >
                <a
                  href="${pageHref('articles')}"
                  >${t.news.pressReleases}</a
                >
                <a
                  href="#"
                  >${t.news.articles}</a
                >
              </div>
            </div>

            <div class="mobile-menu-item w-full">
              <div
                class="mobile-menu-toggle hover:b-l-2 mx-auto flex h-8 w-full cursor-pointer items-center justify-between border-l border-l-white pl-4 duration-300 hover:border-l-green-500 hover:pl-8 hover:text-blue-500"
              >
                <span>${t.menu.company}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="size-4 transition-transform duration-300"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                  />
                </svg>
              </div>
              <div
                class="mobile-submenu hidden flex-col pt-2 pl-8"
              >
                <a
                  href="${pageHref('about-us')}"
                  >${t.company.aboutUs}</a
                >
                <a
                  href="#"
                  >${t.company.history}</a
                >
                <a
                  href="${pageHref('career')}"
                  >${t.company.careers}</a
                >
                <a
                  href="${pageHref('partner')}"
                  >${t.company.globalPartners}</a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- end mobile menu -->
      </nav>
    </header>
    `

    // 设置 logo 资源路径，兼容 Vite 构建
    const logoImg = this.querySelector('#samt-nav-logo')
    if (logoImg) {
      try {
        logoImg.src = new URL(
          '../../assets/svg/web-SAMT-negative.svg',
          import.meta.url
        ).href
      } catch (e) {
        // 兜底：如果解析失败，保持原样（方便开发环境观察问题）
        console.warn('[SamtNav] logo 资源解析失败：', e)
      }
    }

    this.highlightActiveLinks()
  }

  highlightActiveLinks() {
    if (typeof window === 'undefined') return

    const activeUnderlineBaseClasses = [
      'underline',
      'decoration-2',
      'underline-offset-6'
    ]

    const normalizePath = (path) => {
      if (!path || path === '/') return '/'
      return path.replace(/\/index\.html$/, '/')
    }

    const normalizeQuery = (search) => {
      if (!search) return ''
      const params = new URLSearchParams(search.replace(/^\?/, ''))
      return Array.from(params.entries())
        .sort(([aKey, aVal], [bKey, bVal]) =>
          aKey === bKey ? aVal.localeCompare(bVal) : aKey.localeCompare(bKey)
        )
        .map(([key, value]) => `${key}=${value}`)
        .join('&')
    }

    const currentURL = new URL(window.location.href)
    const currentPath = normalizePath(currentURL.pathname)
    const currentQuery = normalizeQuery(currentURL.search)

    this.querySelectorAll(
      '.wideBody-item a[href], .mobile-submenu a[href]'
    ).forEach((link) => {
      const href = link.getAttribute('href')
      if (!href || href.startsWith('#')) return

      let linkURL
      try {
        linkURL = new URL(href, window.location.origin)
      } catch (err) {
        console.warn('[SamtNav] 导航链接解析失败：', href, err)
        return
      }

      const linkPath = normalizePath(linkURL.pathname)
      const linkQuery = normalizeQuery(linkURL.search)
      const isActive = linkPath === currentPath && linkQuery === currentQuery

      if (isActive) {
        const isDesktopLink = !!link.closest('.wideBody-item')
        const isMobileLink = !!link.closest('.mobile-submenu')

        if (isDesktopLink) {
          link.classList.add(
            'text-samt-200!',
            ...activeUnderlineBaseClasses,
            'decoration-samt-200'
          )

          const navMenuItem = link.closest('.nav-menu-li')
          const navMenuTitle = navMenuItem
            ? Array.from(navMenuItem.children).find(
                (child) =>
                  child.tagName === 'SPAN' && child.classList.contains('px-6')
              )
            : null

          if (navMenuTitle) {
            navMenuTitle.classList.add(
              ...activeUnderlineBaseClasses,
              'decoration-white'
            )
          }
        }

        if (isMobileLink) {
          link.classList.add(
            'text-samt-200!',
            ...activeUnderlineBaseClasses,
            'decoration-samt-200'
          )
          link.setAttribute('data-active-nav', 'true')

          const mobileSubmenu = link.closest('.mobile-submenu')
          const mobileMenuItem = link.closest('.mobile-menu-item')
          const mobileToggle = mobileMenuItem
            ? mobileMenuItem.querySelector('.mobile-menu-toggle')
            : null
          const mobileToggleLabel = mobileToggle
            ? mobileToggle.querySelector('span')
            : null
          const mobileArrow = mobileToggle
            ? mobileToggle.querySelector('svg')
            : null

          if (mobileToggle) {
            mobileToggle.classList.add(
              'border-l-green-500',
              'text-samt-200',
              'font-semibold',
              'pl-6'
            )
          }
          if (mobileToggleLabel) {
            mobileToggleLabel.classList.add(
              ...activeUnderlineBaseClasses,
              'decoration-samt-200'
            )
          }

          if (mobileSubmenu) {
            mobileSubmenu.classList.remove('hidden')
            mobileSubmenu.classList.add('flex')
          }

          if (mobileArrow) {
            mobileArrow.style.transform = 'rotate(180deg)'
          }
        }
      }
    })
  }

  initNavbar() {
    // 作用域限定为组件内部，避免与页面其他元素冲突
    const root = this
    // 获取所有带子菜单的菜单项（组件内）
    const menuItems = root.querySelectorAll('.mobile-menu-item')

    menuItems.forEach((item) => {
      const toggle = item.querySelector('.mobile-menu-toggle')
      const submenu = item.querySelector('.mobile-submenu')
      const arrow = toggle.querySelector('svg')

      toggle.addEventListener('click', function (e) {
        e.stopPropagation()

        // 切换当前菜单的展开状态
        const isExpanded = !submenu.classList.contains('hidden')

        // 关闭所有其他打开的子菜单
        document.querySelectorAll('.mobile-submenu').forEach((menu) => {
          if (menu !== submenu) {
            menu.classList.add('hidden')
            menu
              .closest('.mobile-menu-item')
              .querySelector('svg').style.transform = 'rotate(0deg)'
          }
        })

        // 切换当前子菜单
        submenu.classList.toggle('hidden', isExpanded)
        submenu.classList.toggle('flex', !isExpanded)
        arrow.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(180deg)'
      })
    })

    // 点击其他地方关闭所有子菜单
    document.addEventListener('click', function (e) {
      // 点击到组件之外或组件内部但非菜单项区域时，关闭组件内所有子菜单
      const clickedInside = root.contains(e.target)
      const clickedMenuItem = e.target.closest('.mobile-menu-item')
      const clickedOpenMenuBtn = e.target.closest('#open-mobile-menu')
      if (!clickedInside || (clickedInside && !clickedMenuItem)) {
        // 点击打开菜单按钮时，不触发子菜单收起，避免与自动展开当前菜单冲突
        if (clickedOpenMenuBtn) return
        root.querySelectorAll('.mobile-submenu').forEach((menu) => {
          menu.classList.add('hidden')
          const mi = menu.closest('.mobile-menu-item')
          if (mi) {
            const icon = mi.querySelector('svg')
            if (icon) icon.style.transform = 'rotate(0deg)'
          }
        })
      }
    })

    // 获取元素
    const mobileMenu = root.querySelector('#mobile-menu')
    const openMenuBtn = root.querySelector('#open-mobile-menu')
    const closeMenuBtn = root.querySelector('#close-mobile-menu')
    const activeUnderlineBaseClasses = [
      'underline',
      'decoration-2',
      'underline-offset-6'
    ]
    const expandActiveMobileMenu = () => {
      const activeLink = root.querySelector(
        '.mobile-submenu a[data-active-nav="true"]'
      )
      if (!activeLink) return

      const activeSubmenu = activeLink.closest('.mobile-submenu')
      const activeMenuItem = activeLink.closest('.mobile-menu-item')
      const activeToggle = activeMenuItem
        ? activeMenuItem.querySelector('.mobile-menu-toggle')
        : null
      const activeToggleLabel = activeToggle
        ? activeToggle.querySelector('span')
        : null
      const activeArrow = activeToggle
        ? activeToggle.querySelector('svg')
        : null

      if (activeSubmenu) {
        activeSubmenu.classList.remove('hidden')
        activeSubmenu.classList.add('flex')
      }

      if (activeToggle) {
        activeToggle.classList.add(
          'border-l-green-500',
          'text-samt-200',
          'font-semibold',
          'pl-6'
        )
      }
      if (activeToggleLabel) {
        activeToggleLabel.classList.add(
          ...activeUnderlineBaseClasses,
          'decoration-samt-200'
        )
      }

      if (activeArrow) {
        activeArrow.style.transform = 'rotate(180deg)'
      }
    }

    // 打开菜单
    if (openMenuBtn) {
      openMenuBtn.addEventListener('click', function () {
        if (mobileMenu) {
          mobileMenu.classList.remove('hidden', 'translate-x-full')
          mobileMenu.classList.add('translate-x-0')
          expandActiveMobileMenu()
        }
      })
    }

    // 关闭菜单
    if (closeMenuBtn) {
      closeMenuBtn.addEventListener('click', function () {
        if (mobileMenu) {
          mobileMenu.classList.remove('translate-x-0')
          mobileMenu.classList.add('translate-x-full')
          // 延迟添加hidden类，等动画完成
          setTimeout(() => {
            mobileMenu.classList.add('hidden')
          }, 300)
        }
      })
    }

    // 点击菜单外部区域关闭菜单
    document.addEventListener('click', function (e) {
      if (
        mobileMenu &&
        !mobileMenu.classList.contains('hidden') &&
        !e.target.closest('#mobile-menu') &&
        !e.target.closest('#open-mobile-menu') &&
        root.contains(e.target) // 仅在点击到组件内部非菜单区域时处理
      ) {
        mobileMenu.classList.remove('translate-x-0')
        mobileMenu.classList.add('translate-x-full')
        setTimeout(() => {
          mobileMenu.classList.add('hidden')
        }, 300)
      }
    })

    // 导航栏滚动效果
    let lastScrollTop = 0
    let ticking = false

    function updateNavbar() {
      const nav = root.querySelector('nav')
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop

      if (currentScrollTop > lastScrollTop) {
        // 向下滚动 - 隐藏导航栏
        nav.style.transform = 'translateY(-100%)'
      } else {
        // 向上滚动 - 显示导航栏
        nav.style.transform = 'translateY(0)'
      }

      // 无论滚动方向如何，都要根据当前位置设置背景色
      if (currentScrollTop > 50) {
        nav.classList.remove('lg:bg-transparent')
        nav.classList.add('!bg-samt')

        nav.classList.remove('shadow-none')
        nav.classList.add('shadow-2xl')
      } else {
        nav.classList.add('lg:bg-transparent')
        nav.classList.remove('!bg-samt')

        nav.classList.remove('shadow-2xl')
        nav.classList.add('shadow-none')
      }

      lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop
      ticking = false
    }

    function requestTick() {
      if (!ticking) {
        requestAnimationFrame(updateNavbar)
        ticking = true
      }
    }

    // 监听滚动事件
    window.addEventListener('scroll', requestTick)

    // 语言切换事件
    const langSwitcher = root.querySelector('#lang-switcher')
    if (langSwitcher) {
      langSwitcher.addEventListener('click', (e) => {
        const target = e.target.closest('[data-lang]')
        if (target) {
          const lang = target.dataset.lang
          setLang(lang)
        }
      })
    }
  }
}
customElements.define('samt-header', SamtHeader)
